module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-20GIU-25-ff630c133c3a9f1ccfad33ddb3f98dd0.jpg";